export default "__VITE_ASSET__f1a12560__"